<div class="row" style="font-family: 'Inconsolata', monospace;">

    <div class="col-md-12" style="margin-bottom: 10px;">
        <div class="accounts-toolbar">
            <input type="text" class="form-control accounts-search" [(ngModel)]="searchTerm"
                placeholder="Rechercher par login ou titre...">
            <button type="button" class="btn btn-primary" (click)="openAddDialog()">
                <i class="fa fa-plus"></i> Ajouter
            </button>
        </div>
    </div>

    <div class="col-lg-3 col-md-4 col-sm-6 col-xs-12" *ngFor="let account of filteredAccounts">
        <app-account-form [user]="account" [mode]="'SHOW'" [isCollabsed]="false">

        </app-account-form>
    </div>

    <div class="col-md-12" *ngIf="accounts && accounts?.length > 0 && filteredAccounts?.length == 0 && !loading">
        <div class="alert alert-warning alert-dismissible">
            <button type="button" class="close" data-dismiss="alert" aria-hidden="true">×</button>
            <h4><i class="icon fa fa-info"></i> Info !</h4>
            Aucun compte ne correspond à votre recherche.
        </div>
    </div>

    <div class="col-md-12" *ngIf="(!accounts || accounts?.length == 0) && !loading">
        <div class="alert alert-warning alert-dismissible">
            <button type="button" class="close" data-dismiss="alert" aria-hidden="true">×</button>
            <h4><i class="icon fa fa-info"></i> Info !</h4>
            Vous n'avez pas de sous compte pour l'instant..!
        </div>
    </div>

    <div class="col-md-12" *ngIf="loading">
        <div class="alert alert-success alert-dismissible">
            <button type="button" class="close" data-dismiss="alert" aria-hidden="true">×</button>
            <h4><i class="icon fa fa-info"></i> Info !</h4>
            Chargement..!
        </div>
    </div>

</div>

<ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '0px',fullScreenBackdrop:true }"></ngx-loading>
